import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import {Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, IconButton, Input, InputLabel, TextareaAutosize, Typography} from '@material-ui/core'
import {Container, Box, Grid} from '@material-ui/core'
import { Checkbox } from '@material-ui/core'
//FormControl InputLabel, Select, MenuItem, TextField
import {Button, TextField} from '@material-ui/core';
//import PersonIcon from '@material-ui/icons/Person';

import { getBase64ID, getObjectByID } from '../../../api/helpers';
import { ControlCameraOutlined, MoreVert } from '@material-ui/icons';
import { SelectGroupsDialog } from './SelectGroupsDialog';


class GroupPatchDialog_ extends React.Component{

    constructor(props){
        super(props)

        //console.log('GroupPatchDialog_ constructor')
        //console.log('props')
        //console.log(props)

        let groupPatch = props.groupPatch ? props.groupPatch : this.getDefaults();


        this.state = {
            groupPatch: groupPatch,
            errors:{
                Name: false,
            },
            changed: false,
            selectGroupsDialog:{
                open: false,
                groups: {}//groupPatch.SubGroups
            }
        }


        this.handleInput =  this.handleInput.bind(this)
        this.handleAction = this.handleAction.bind(this)
        this.openSelectGroupsDialog = this.openSelectGroupsDialog.bind(this)
    }

    getDefaults(){
        return {
            Name: this.props.onAction({type: 'GENERATE_NEW_NAME'}),
            Enabled: true,

            //ID: getBase64ID(),
            Type: 1, //dynamic
            SubGroups: [],
            Operation: 1
        }
    }

    handleSave(){
        if(this.validate()){
            let groupPatch = {...this.state.groupPatch}
            this.props.onAction({
                type: 'GROUP_PATCH_DIALOG_SAVE', 
                groupPatch: groupPatch,
                networkID: this.props.networkID
            })
        }
    }

    handleClose(){
        if(this.state.changed){
            if(!window.confirm(this.props.t('CloseFormConfirm'))) return; 
        }
        this.props.onAction({type: 'GROUP_PATCH_DIALOG_CLOSE'})
    }

    handleInput(event){
        let changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
        const groupPatch = {...this.state.groupPatch, [event.target.name]: val}
        this.setState({groupPatch: groupPatch, ...changed})
    }

    validate(){
        const {t} = this.props

        let errors = this.state.errors;
        let error = false

        
        if(!this.state.groupPatch.Name){
            errors.ChannelNum = t('NameIsEmpty')
            error = true
        }
        /*
        if(this.state.properties.pollingEnabled && !isNumber(this.state.properties.pollingTime)){
            errors.pollingTime = t('IsNotNumber')
            error = true
        }else{
            errors.pollingTime = false
        }
/*
        if(!this.state.channel.ChannelName){
            errors.ChannelName = t('NameIsEmpty')
            error = true
        }else{
            errors.ChannelName = false
        }
        this.setState({errors: errors})
        */

        return !error;
    }

    openSelectGroupsDialog(){
        let selectGroupsDialog = this.state.selectGroupsDialog

        selectGroupsDialog.open = true
        selectGroupsDialog.groups = this.state.groupPatch.SubGroups
        selectGroupsDialog.networks = this.props.networks

        this.setState({selectGroupsDialog: selectGroupsDialog})
    }


    handleAction(action){
        switch(action.type){
            case 'SELECT_GROUPS_DIALOG_CLOSE':{
                let selectGroupsDialog = this.state.selectGroupsDialog
                selectGroupsDialog.open = false
                
                this.setState({selectGroupsDialog: selectGroupsDialog})
                break;
            }

            case 'SELECT_GROUPS_DIALOG_SELECT':{
                let groupPatch = {...this.state.groupPatch}
                groupPatch.SubGroups = action.groups

                let selectGroupsDialog = this.state.selectGroupsDialog
                selectGroupsDialog.open = false

                this.setState({selectGroupsDialog: selectGroupsDialog, groupPatch: groupPatch})
                break;
            }

            default:
                console.log('Undefined action case: '+action.type)
        }
        
    }

    getGroupName(item){
        console.log('getGroupName')
        console.log(item)
        console.log(this.props.networks)

        let net = getObjectByID(item.NetworkID, this.props.networks)
        let group = getObjectByID(item.GroupID, net.groups)

        return (net?net.Name + ' / ':'') + (group?group.Name:'')
    }


    render(){
        const {t} = this.props

        const title = t('GroupPatch')

        const margin = {margin:'16px 0 8px 0'}


        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="properties-dialog-title">


    {this.state.selectGroupsDialog.open? (
        <SelectGroupsDialog open={this.state.selectGroupsDialog.open}
            networks={this.props.networks}
            groups={this.state.selectGroupsDialog.groups}
            onAction={this.handleAction} ></SelectGroupsDialog>
    ) : null }
        
    <DialogTitle id="properties-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:300}}>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <TextField name="Name"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.Name?this.state.errors.Name:t('Name')}
                    autoComplete="off"
                    error={this.state.errors.Name!==false}
                    value={this.state.groupPatch.Name}
                    onChange={this.handleInput.bind(this)}
                />
            </Box>

            <Box style={{...margin, width: '100%'}}>
            <FormControl>
                <label>
                    <Checkbox color="primary"
                        checked={this.state.groupPatch.Enabled}
                        onChange={this.handleInput}
                        name="Enabled"
                    />
                    {t('Enabled')}
                </label>
            </FormControl>
            </Box>

            <Box style={{...margin, width: '100%'}}>      
                <Grid container>
                    <Grid item xs={11} align="left">

                    <TextField
                        style={{width: '100%'}}
                        id="Members"
                        label={t('Members')}
                        multiline
                        variant="outlined"
                        rows={5}
                        InputProps={{readOnly: true}}
                        value={this.state.groupPatch.SubGroups.map(item=>this.getGroupName(item)).join('\r\n')}
                    />

                    </Grid>
                    <Grid item xs={1} style={{verticalAlign:'bottom', paddingTop:8}}>

                        <IconButton onClick={this.openSelectGroupsDialog}><MoreVert /></IconButton>

                    </Grid>
                </Grid>
            </Box>
        
        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSave.bind(this)} variant="contained" color="primary">
            {t('Apply')}
        </Button>
        <Button onClick={this.handleClose.bind(this)} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}


export const GroupPatchDialog = withTranslation()(GroupPatchDialog_);